import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingSpinner } from '../../../components/base';
import { AppRedirectPageWrapper } from '../AppRedirectPage/styles';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import { makeSelectOrg } from '../../Root/selectors';
var OrgRedirectPage = function () {
    var location = useLocation();
    var org = useSelector(makeSelectOrg());
    var tokenAsQuery = new URLSearchParams(location.search).get('token');
    var existingToken = localStorage.getItem('token');
    return (!tokenAsQuery || (tokenAsQuery && existingToken === tokenAsQuery)) &&
        org &&
        org.selectedOrganizationId !== '' ? (_jsx(Navigate, { to: "/organizations/".concat(org.selectedOrganizationId, "/apps"), replace: true })) : (_jsx(AppRedirectPageWrapper, { children: _jsx(LoadingSpinner, {}) }));
};
export default OrgRedirectPage;
